module.exports = __webpack_public_path__ + "static/media/oljud.06c25738.mp3";